
import { Link } from 'react-router-dom';
import { services } from '../../mocks/services';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ServicesPage = () => {
  return (
    <div className="min-h-screen bg-primary-black">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        {/* Background effects */}
        <div className="absolute inset-0">
          <div className="absolute inset-0" style={{
            backgroundImage: `radial-gradient(circle at 30% 30%, rgba(0, 212, 255, 0.25) 0%, transparent 50%),
                             radial-gradient(circle at 70% 70%, rgba(0, 102, 255, 0.2) 0%, transparent 50%),
                             radial-gradient(circle at 50% 50%, rgba(0, 180, 255, 0.15) 0%, transparent 60%)`
          }}></div>
          <div className="absolute top-1/4 left-1/3 w-96 h-96 bg-primary-blue/20 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-1/4 right-1/3 w-80 h-80 bg-cyan-500/15 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-3 mb-6">
            <div className="w-16 h-px bg-gradient-to-r from-transparent to-primary-blue"></div>
            <span className="text-primary-blue font-inter text-sm font-semibold tracking-widest uppercase" style={{ textShadow: '0 0 20px rgba(0, 212, 255, 0.8)' }}>
              Premium Solutions
            </span>
            <div className="w-16 h-px bg-gradient-to-l from-transparent to-primary-blue"></div>
          </div>
          <h1 className="text-5xl md:text-7xl font-orbitron font-bold text-white mb-6" style={{ textShadow: '0 0 50px rgba(0, 212, 255, 0.8)' }}>
            ELITE SERVICES
          </h1>
          <p className="text-xl text-gray-300 font-inter max-w-2xl mx-auto mb-8">
            20+ Premium Detailing Solutions at the Best Prices in the Market
          </p>
          <Link 
            to="/#contact"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-primary-blue to-cyan-400 text-black font-inter font-bold rounded-xl transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
            style={{ boxShadow: '0 0 40px rgba(0, 212, 255, 0.6)' }}
          >
            <i className="ri-calendar-line text-xl"></i>
            BOOK YOUR SERVICE
          </Link>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 relative">
        <div className="absolute inset-0 bg-gradient-to-b from-primary-black via-primary-dark/50 to-primary-black"></div>
        
        {/* Decorative elements */}
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-blue/50 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-cyan-400/50 to-transparent"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6">
          {/* Category: Wash & Clean */}
          <div className="mb-16">
            <div className="flex items-center gap-4 mb-8">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br from-primary-blue/30 to-cyan-400/30 border border-primary-blue/50" style={{ boxShadow: '0 0 20px rgba(0, 212, 255, 0.4)' }}>
                <i className="ri-water-flash-line text-2xl text-primary-blue"></i>
              </div>
              <h2 className="text-3xl font-orbitron font-bold text-white" style={{ textShadow: '0 0 20px rgba(0, 212, 255, 0.5)' }}>
                WASH & CLEAN
              </h2>
              <div className="flex-1 h-px bg-gradient-to-r from-primary-blue/50 to-transparent"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {services.slice(0, 4).map((service) => (
                <ServiceCard key={service.id} service={service} />
              ))}
            </div>
          </div>

          {/* Category: Ceramic Coating */}
          <div className="mb-16">
            <div className="flex items-center gap-4 mb-8">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br from-cyan-400/30 to-teal-400/30 border border-cyan-400/50" style={{ boxShadow: '0 0 20px rgba(0, 255, 200, 0.4)' }}>
                <i className="ri-shield-star-line text-2xl text-cyan-400"></i>
              </div>
              <h2 className="text-3xl font-orbitron font-bold text-white" style={{ textShadow: '0 0 20px rgba(0, 255, 200, 0.5)' }}>
                CERAMIC COATING
              </h2>
              <div className="flex-1 h-px bg-gradient-to-r from-cyan-400/50 to-transparent"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {services.slice(4, 7).map((service) => (
                <ServiceCard key={service.id} service={service} color="cyan" />
              ))}
            </div>
          </div>

          {/* Category: Interior Care */}
          <div className="mb-16">
            <div className="flex items-center gap-4 mb-8">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br from-teal-400/30 to-emerald-400/30 border border-teal-400/50" style={{ boxShadow: '0 0 20px rgba(0, 200, 150, 0.4)' }}>
                <i className="ri-sparkling-2-line text-2xl text-teal-400"></i>
              </div>
              <h2 className="text-3xl font-orbitron font-bold text-white" style={{ textShadow: '0 0 20px rgba(0, 200, 150, 0.5)' }}>
                INTERIOR CARE
              </h2>
              <div className="flex-1 h-px bg-gradient-to-r from-teal-400/50 to-transparent"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {[services[7], services[10], services[11], services[12], services[18]].map((service) => (
                <ServiceCard key={service.id} service={service} color="teal" />
              ))}
            </div>
          </div>

          {/* Category: Paint & Exterior */}
          <div className="mb-16">
            <div className="flex items-center gap-4 mb-8">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br from-primary-blue/30 to-indigo-400/30 border border-primary-blue/50" style={{ boxShadow: '0 0 20px rgba(100, 150, 255, 0.4)' }}>
                <i className="ri-brush-line text-2xl text-primary-blue"></i>
              </div>
              <h2 className="text-3xl font-orbitron font-bold text-white" style={{ textShadow: '0 0 20px rgba(100, 150, 255, 0.5)' }}>
                PAINT & EXTERIOR
              </h2>
              <div className="flex-1 h-px bg-gradient-to-r from-primary-blue/50 to-transparent"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {[services[2], services[3], services[9], services[13], services[14], services[17]].map((service) => (
                <ServiceCard key={service.id} service={service} />
              ))}
            </div>
          </div>

          {/* Category: Specialty Services */}
          <div className="mb-16">
            <div className="flex items-center gap-4 mb-8">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br from-amber-400/30 to-orange-400/30 border border-amber-400/50" style={{ boxShadow: '0 0 20px rgba(255, 180, 0, 0.4)' }}>
                <i className="ri-vip-crown-line text-2xl text-amber-400"></i>
              </div>
              <h2 className="text-3xl font-orbitron font-bold text-white" style={{ textShadow: '0 0 20px rgba(255, 180, 0, 0.5)' }}>
                SPECIALTY SERVICES
              </h2>
              <div className="flex-1 h-px bg-gradient-to-r from-amber-400/50 to-transparent"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {[services[8], services[15], services[16], services[19]].map((service) => (
                <ServiceCard key={service.id} service={service} color="amber" />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-r from-primary-blue/20 via-cyan-500/20 to-teal-500/20"></div>
          <div className="absolute inset-0" style={{
            backgroundImage: `radial-gradient(circle at 50% 50%, rgba(0, 212, 255, 0.3) 0%, transparent 60%)`
          }}></div>
        </div>
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-blue to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-cyan-400 to-transparent"></div>

        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-orbitron font-bold text-white mb-6" style={{ textShadow: '0 0 40px rgba(0, 212, 255, 0.8)' }}>
            READY FOR PERFECTION?
          </h2>
          <p className="text-xl text-gray-300 font-inter mb-10">
            Contact us today for a free evaluation and quote. Best prices in Elkhart, Indiana!
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <a
              href="https://wa.me/12694649163"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-3 px-10 py-5 bg-gradient-to-r from-green-500 to-emerald-500 text-white font-inter font-bold text-lg rounded-xl transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
              style={{ boxShadow: '0 0 30px rgba(34, 197, 94, 0.6)' }}
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              WHATSAPP US
            </a>
            <Link
              to="/#contact"
              className="group flex items-center gap-3 px-10 py-5 bg-gradient-to-r from-primary-blue to-cyan-400 text-black font-inter font-bold text-lg rounded-xl transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
              style={{ boxShadow: '0 0 30px rgba(0, 212, 255, 0.6)' }}
            >
              <i className="ri-calendar-line text-2xl"></i>
              BOOK NOW
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

interface ServiceCardProps {
  service: {
    id: number;
    name: string;
    icon: string;
    priceFrom: number;
    description: string;
  };
  color?: 'blue' | 'cyan' | 'teal' | 'amber';
}

const ServiceCard = ({ service, color = 'blue' }: ServiceCardProps) => {
  const colorClasses = {
    blue: {
      border: 'border-primary-blue/40 hover:border-primary-blue',
      icon: 'text-primary-blue',
      price: 'from-primary-blue to-cyan-400',
      glow: 'rgba(0, 212, 255, 0.3)',
      shadow: '0 0 25px rgba(0, 212, 255, 0.2)'
    },
    cyan: {
      border: 'border-cyan-400/40 hover:border-cyan-400',
      icon: 'text-cyan-400',
      price: 'from-cyan-400 to-teal-400',
      glow: 'rgba(0, 255, 200, 0.3)',
      shadow: '0 0 25px rgba(0, 255, 200, 0.2)'
    },
    teal: {
      border: 'border-teal-400/40 hover:border-teal-400',
      icon: 'text-teal-400',
      price: 'from-teal-400 to-emerald-400',
      glow: 'rgba(0, 200, 150, 0.3)',
      shadow: '0 0 25px rgba(0, 200, 150, 0.2)'
    },
    amber: {
      border: 'border-amber-400/40 hover:border-amber-400',
      icon: 'text-amber-400',
      price: 'from-amber-400 to-orange-400',
      glow: 'rgba(255, 180, 0, 0.3)',
      shadow: '0 0 25px rgba(255, 180, 0, 0.2)'
    }
  };

  const colors = colorClasses[color];

  return (
    <div
      className={`group relative bg-gradient-to-b from-primary-dark/90 to-primary-black/90 backdrop-blur-sm rounded-2xl p-6 border-2 ${colors.border} transition-all duration-500 hover:-translate-y-2 cursor-pointer`}
      style={{ boxShadow: colors.shadow }}
    >
      <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: `radial-gradient(circle at center, ${colors.glow}, transparent 70%)` }}></div>
      
      <div className="relative z-10 space-y-4">
        <div className={`w-14 h-14 flex items-center justify-center rounded-xl bg-white/5 border border-white/10 group-hover:scale-110 transition-transform duration-300`}>
          <i className={`${service.icon} text-3xl ${colors.icon}`}></i>
        </div>
        
        <h3 className="text-lg font-inter font-bold text-white group-hover:text-white transition-colors">
          {service.name}
        </h3>
        
        <p className="text-sm text-gray-400 font-inter leading-relaxed">
          {service.description}
        </p>
        
        <div className="pt-2 flex items-center justify-between">
          <span className={`text-2xl font-orbitron font-bold text-transparent bg-clip-text bg-gradient-to-r ${colors.price}`}>
            ${service.priceFrom}+
          </span>
          <span className="text-xs text-gray-500 font-inter">Starting Price</span>
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;
